export default ({ tracking } = {}) => tracking
